export { default } from './InfoTitle';
